module.exports = __webpack_public_path__ + "public/images/Illustration_Music_200x174.c59dd8fd022a76f0d6c370f587f39f59.png";